// 页面公用部分 比如顶部，底部
import CommonMain from './modules/common/commonMain';
new CommonMain();
